const PRODUCT_ATTRIBUTE_TYPES = {
  size: 'size',
  extras: 'extras',
  cookType: 'cookType',
  addition: 'addition',
}

export default PRODUCT_ATTRIBUTE_TYPES;
